import {
    MobileAppLinksButtonsContainerStyled,
    MobileAppLinksDevicesBackgroundStyled,
    MobileAppLinksWrapperStyled
} from "./styled/MobileAppLinksStyled";
import StoreButton from "../../components/store-button/StoreButton";
import { STORE_BUTTON_TYPES } from "../../components/store-button/store-button-constants";
import { isClientIOS } from "../../components/ClientInfo/ClientInfo";
import { Redirect } from "react-router-dom";
import { LANG_CHOOSER_TYPES, LangChooser } from "../LangChooser";
import { MainHeader } from "../../components/main-header/MainHeader";
import { RouterPaths } from "../../app/appConstants";
import { useSetBodyBackgroundColor } from "../../components/UseSetBodyBackgroundColor/useSetBodyBackgroundHooks";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext.js";

const MobileAppLinks = () => {
    const {getLangPath} = useLangContext();
    useSetBodyBackgroundColor('var(--color-white)', true);

    if (isClientIOS) {
        return <Redirect to={RouterPaths.mobileInProgress}/>
    }
    return (
            <MobileAppLinksWrapperStyled>
                <MainHeader>
                    <LangChooser isHideButtonArrowIcon isHideButtonName type={LANG_CHOOSER_TYPES.slider}
                                 gtmModule="Header"/>
                </MainHeader>
                <MobileAppLinksDevicesBackgroundStyled/>
                <h1 className="mb-3">{getLangPath('welcome.almost_start')}</h1>
                <p className="mb-4">{getLangPath('welcome.download_app')}</p>
                <MobileAppLinksButtonsContainerStyled>
                    {/*<StoreButton type={STORE_BUTTON_TYPES.apple} className="mb-4" />*/}
                    <StoreButton type={STORE_BUTTON_TYPES.google}/>
                </MobileAppLinksButtonsContainerStyled>
            </MobileAppLinksWrapperStyled>
    );
};

export default MobileAppLinks;
